import type { Me } from "@feedmark/shared/api";
import { client } from "./api";
import { $ } from "./dom";

// Shows the login link or the logout button. Returns the user that is logged in.
export async function showAccount(): Promise<Me["user"]> {
  const { user }: Me = await client.api.me
    .$get()
    .then((response) => response.json())
    .catch(() => ({ user: null }));
  const login = $<HTMLAnchorElement>("login");
  const logout = $("logout");
  // The links for a user that is logged in. Only some pages have them.
  const mine = document.getElementById("my-prototypes");
  if (mine) mine.hidden = user === null;
  const changes = document.getElementById("text-changes");
  if (changes) changes.hidden = user === null;
  login.hidden = user !== null;
  logout.hidden = user === null;
  login.href = `/auth/login?next=${encodeURIComponent(location.pathname)}`;
  if (user) logout.textContent = `Log out${user.name ? ` (${user.name})` : ""}`;
  logout.addEventListener("click", async () => {
    await client.auth.logout.$post();
    location.reload();
  });
  return user;
}
